import { render, staticRenderFns } from "./specialItem.vue?vue&type=template&id=60a0e0a2&scoped=true"
import script from "./specialItem.vue?vue&type=script&lang=js"
export * from "./specialItem.vue?vue&type=script&lang=js"
import style0 from "./specialItem.vue?vue&type=style&index=0&id=60a0e0a2&prod&lang=scss&scoped=true"
import style1 from "./specialItem.vue?vue&type=style&index=1&id=60a0e0a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0e0a2",
  null
  
)

export default component.exports